import EnButton from 'assets/images/en_button.png';
import FaButton from 'assets/images/fa_button.png';
import BareButton from 'assets/images/bare_button.png';
import useInputKeys from 'hooks/useInputKeys';
import './index.scss';

function Switch() {
  const { setInputType } = useInputKeys();
    return (
        <div className="switch-wrapper">
          <img src={FaButton} alt="Farsi Button" onClick={() => setInputType('fa')} />
          <img src={BareButton} alt="Bare Button" onClick={() => setInputType('num')} />
          <img src={EnButton} alt="English Button" onClick={() => setInputType('en')} />
        </div>
    );
}

export default Switch;
